import script from "./ProfileSettingsAccounNotifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileSettingsAccounNotifications.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__